import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTModalCard = _resolveComponent("KTModalCard")!
  const _component_AddTicketModal = _resolveComponent("AddTicketModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_KTModalCard, {
      title: "Hola!",
      description: "Acá puedes ingresar una solicitud o reclamo que será atendido por nuestros ejecutivos",
      image: _ctx.getIllustrationsPath('2.png'),
      "button-text": "Nueva Solicitud",
      "modal-id": "kt_modal_add_ticket"
    }, null, 8, ["image"]),
    _createVNode(_component_AddTicketModal)
  ], 64))
}